// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from "vue-router";
import Axios from 'axios'
import ElementUI from 'element-ui'
import less from 'less'
import './assets/font.css';
import { VueMasonryPlugin } from 'vue-masonry';

import * as echarts from 'echarts';

// import '@/utils/china'
import '@/utils/world'
import 'element-ui/lib/theme-chalk/index.css'
// import '@/utils/snorql'
Vue.config.productionTip = false
Vue.prototype.$axios=Axios

// Vue.prototype.$baseurl='https://datastore.acemap.info/'
Vue.prototype.$baseurl=window.location.href.indexOf("10.")>=0?'https://dataexpo.acemap.info/':'https://dataexpo.acemap.info/'
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(less)
Vue.use(echarts)
Vue.use(VueMasonryPlugin)
// Vue.use(leaflet)
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/main.js